// Generic internal-path guard for the /login page's `returnUrl` query param.
// Rejects absolute URLs (http/https), protocol-relative (//), and path traversal (..).
export function validateReturnUrl(value: string | null): string | null {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return null;
  if (value.startsWith('//')) return null;
  if (value.includes('..')) return null;
  if (!value.startsWith('/')) return null;
  return value;
}

// Builds the in-app Descope `/login` route for a return path, validated against the
// same open-redirect guard `LoginPage` uses when it reads `returnUrl` back off the
// query string. Center-PWA hosts sign-in itself now (HashRouter), so this is a route
// to `navigate()` to, not a cross-app redirect URL.
export function signInForAction(returnTo: string): string {
  const validated = validateReturnUrl(returnTo);
  return `/login?returnUrl=${encodeURIComponent(validated ?? '/')}`;
}
